import { readFile, writeFile } from "fs/promises";
import { dirname, join } from "path";
import FSExtra from "fs-extra";
import { removeSupportedExtensions } from "../router/matchers";
import { globbedRoutesToRouteContext } from "../router/useViteRoutes";
import { getRoutePaths } from "../utils/routeIndex";
import { getTypedRoutesDeclarationFile } from "./getTypedRoutesDeclarationFile";
import { injectRouteHelpers } from "./injectRouteHelpers";
async function generateRouteTypes(outFile, routerRoot, ignoredRouteFiles, typedRoutesMode, routePathsIn) {
  var routePaths = routePathsIn !== null && routePathsIn !== void 0 ? routePathsIn : getRoutePaths(routerRoot, ignoredRouteFiles);
  var routes = routePaths.reduce(function(acc, cur) {
    var vitePath = `/${routerRoot}/${cur.replace(/^\.\//, "")}`;
    acc[vitePath] = {};
    return acc;
  }, {});
  var context = globbedRoutesToRouteContext(routes, routerRoot);
  var declarations = getTypedRoutesDeclarationFile(context);
  var outDir = dirname(outFile);
  var currentDeclarations;
  try {
    currentDeclarations = await readFile(outFile, "utf8");
  } catch (error) {
    if (error.code !== "ENOENT") {
      throw error;
    }
  }
  if (currentDeclarations !== declarations) {
    await FSExtra.ensureDir(outDir);
    await writeFile(outFile, declarations);
  }
  if (typedRoutesMode) {
    var mode = typedRoutesMode === "type" ? "type" : "runtime";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = routePaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var routePath = _step.value;
        if (routePath.includes("_layout") || routePath.includes("+api") || routePath.startsWith("_") || routePath.endsWith(".d.ts")) {
          continue;
        }
        var fullPath = join(process.cwd(), routerRoot, routePath);
        var routeName = routePath.replace(/^\.\//, "").replace(/\+[^/]*$/, "").replace(/\/index$/, "").replace(/index$/, "");
        var cleanRouteName = removeSupportedExtensions(routeName).replace(/\/?index$/, "");
        if (!cleanRouteName.startsWith("/")) {
          cleanRouteName = "/" + cleanRouteName;
        }
        if (!cleanRouteName.includes("[")) {
          continue;
        }
        await injectRouteHelpers(fullPath, cleanRouteName, mode);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}
export {
  generateRouteTypes
};
//# sourceMappingURL=generateRouteTypes.js.map
